import { action, makeObservable, observable, runInAction } from 'mobx';
import { Nullable } from '../../core';
import { notifyError, notifySuccess } from '../../services/notifications';
import { Store } from '../../store/store';
import { Message, StoreNode } from '../../store';
import { WindowState } from '../overlays/windowState';
import Routes from '../../routes';

export class DeleteBookmarkListWindowState
  extends StoreNode {

  readonly nodeType = 'DeleteBookmarkListWindow';

  constructor(store: Store) {
    super(store);
    makeObservable<this, 'windowListener'>(this, {
      isLoading: observable,
      bookmarkListId: observable,
      shouldRedirect: observable,
      submit: action,
      windowListener: action,
      open: action,
      close: action,
    });

    this.window.listen(
      this.windowListener);
  }

  readonly window = new WindowState(this.store);

  isLoading: boolean = false;
  bookmarkListId: Nullable<string> = null;
  shouldRedirect: boolean = false;

  async submit() {
    if (!this.bookmarkListId) return;

    this.isLoading = true;

    const [, err] = await this.store.apiDeleteBookmarkList({ id: this.bookmarkListId });
    if (err)
      return notifyError(this, 'Could not delete bookmark list.');

    this.handleSubmitFinally();
    notifySuccess(this, 'Bookmark list deleted.');
  }

  handleSubmitFinally() {
    runInAction(() => {
      this.isLoading = false;
      if (this.shouldRedirect) this.store.goTo(Routes.bookmarks());
      this.close();
    })
  }

  private windowListener = (msg: Message<WindowState>) => {
    switch (msg.type) {
      case 'close':
      case 'outsideClick':
        this.close();
        break;
    }
  }

  open({ bookmarkListId, shouldRedirect = false }: { bookmarkListId: string, shouldRedirect?: boolean }) {
    this.dispatch('Overlays', 'openWindow', { name: 'DeleteBookmarkListWindow' });

    this.bookmarkListId = bookmarkListId;
    this.shouldRedirect = shouldRedirect;
  }

  close() {
    this.bookmarkListId = null;
    this.shouldRedirect = false;

    this.emit('close');
    this.dispatch('Overlays', 'closeWindow');
  }
}